import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import * as sha1 from 'js-sha1';

import * as _ from 'lodash'


import { ReponseWebService } from '../datastruct/Meloyi.module';



const httpOptions = {
	headers: new HttpHeaders(
		{
			'Content-Type': 'application/json',
		}
	)
};



@Injectable({
	providedIn: 'root'
})
export class GestockService {

	baseUrlRem1 = "https://dkm.sentelecom.com/gestion/";

	constructor(private http: HttpClient) { }

	// updateDepotName(samacaabiyoonwii: string, idDepot: number, nouveauNom: string): Promise<any> {
	// 	const payload = { samacaabiyoonwii, idDepot, nouveauNom };
	// 	return this.http.post<any>(this.baseUrlRem1 + 'updateDepotName.php', payload).toPromise();
	// }

	manualUpdateCMUP(samacaabiyoonwii: string, article_id: number, newCMUP: number): Promise<any> {
		const payload = { samacaabiyoonwii, article_id, newCMUP };
		return this.http.post<any>(this.baseUrlRem1 + 'manualUpdateCMUP.php', payload).toPromise();
	}

	uploadLogo(file: File): Promise<any> {
		const formData = new FormData();
		formData.append('logo', file);
		return this.http.post<any>(this.baseUrlRem1 + 'uploadLogo.php', formData).toPromise();
	}

	updateShopInfo(info: any): Promise<any> {
		return this.http.post<any>(this.baseUrlRem1 + 'updateShopInfo.php', info).toPromise();
	}

	getShopInfo(samacaabiyoonwii: string): Promise<any> {
		const payload = { samacaabiyoonwii };
		return this.http.post<any>(this.baseUrlRem1 + 'getShopInfo.php', payload).toPromise();
	}

	hasClientARecouvrer(samacaabiyoonwii: string): Promise<boolean> {
		const payload = { samacaabiyoonwii: samacaabiyoonwii };
		return this.http.post<any>(this.baseUrlRem1 + 'hasClientARecouvrer.php', payload)
			.toPromise()
			.then(res => res?.statutreq === 1 && res.hasClientARecouvrer === true);
	}


	addCategorie(samacaabiyoonwii: string, nomcategorie: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, nomcategorie: nomcategorie };
			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'addCategorie.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getClientAndStats(samacaabiyoonwii: string, idboutique, debut, fin): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, date_debut: debut, date_fin: fin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'clients_par_boutique.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getallclients(samacaabiyoonwii: string, idboutique): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getallclients.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getSamaHistoRecouvr(samacaabiyoonwii: string, idclient, idboutique): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, idboutique: idboutique, idclient: idclient };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getSamaHistoRecouvr.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	recouvrements_cumules_par_client(samacaabiyoonwii: string, idboutique, debut, fin): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, date_debut: debut, date_fin: fin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'recouvrements_cumules_par_client.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getStatStockBoutique(samacaabiyoonwii: string, idboutique): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getStatStockBoutique.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getStatArticle(samacaabiyoonwii: string, articleId, boutiqueId): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, article_id: articleId, boutique_id: boutiqueId };
			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'getStatArticle.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}

	updateRecouvrementClient(samacaabiyoonwii: string, idclient, idboutique, montant): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = {
				samacaabiyoonwii: samacaabiyoonwii, idclient: idclient,
				idboutique: idboutique, montant: montant
			};
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'updateRecouvrementClient.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getClientById(samacaabiyoonwii: string, idclient): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, idclient: idclient };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getClientById.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	creerclient(samacaabiyoonwii: string, client): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, client: client };

			console.log(postData);

			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'creerclient.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	commanderPanier(samacaabiyoonwii: string, panierCommande, quantities, paymean, montantPaye, client, dateEcheance: string = null): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = {
				samacaabiyoonwii: samacaabiyoonwii,
				panier: panierCommande, quantities: quantities,
				montantPaye: montantPaye, client: client,
				paymean: paymean, dateEcheance: dateEcheance
			};

			console.log(postData);

			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'commanderPanier.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	updateCommande(samacaabiyoonwii: string, oldNumcmd: string, panierCommande, quantities, paymean, montantPaye, client, dateEcheance: string = null): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = {
				samacaabiyoonwii: samacaabiyoonwii,
				oldNumcmd: oldNumcmd,
				panier: panierCommande, quantities: quantities,
				montantPaye: montantPaye, client: client,
				paymean: paymean, dateEcheance: dateEcheance
			};

			console.log(postData);

			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'updateCommande.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getOriginalCommand(samacaabiyoonwii: string, numcmd: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = {
				samacaabiyoonwii: samacaabiyoonwii,
				idcmd: numcmd
			};

			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'getOriginalCommand.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}

	getReporting(samacaabiyoonwii, idboutique, datedeb, datefin): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, dateDebut: datedeb, dateFin: datefin };
			console.log(postData);

			let backData: ReponseWebService;

			this.remotelogger(this.baseUrlRem1 + 'getReporting.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	getInfoClientBiPlus(samacaabiyoonwii: string, telephoneclient: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, telephoneclient: telephoneclient };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getInfoClientBiPlus.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}



	getInfoPourLiiWalaKii(samacaabiyoonwii: string, idbi: string, cible): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, id: idbi, cible: cible };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getInfoPourLiiWalaKii.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	soppidjiilWaadji(samacaabiyoonwii: string, eltBi: string, cible): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, eltBi: eltBi, cible: cible };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'soppidjiilWaadji.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getInfoClientBi(samacaabiyoonwii: string, telephoneclient: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, telephoneclient: telephoneclient };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getInfoClientBi.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllCategories(samacaabiyoonwii: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAllCategories.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	addProduct(samacaabiyoonwii: string, produitBi: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, produitBi: produitBi };
			let backData: ReponseWebService;
			console.log(postData);
			this.remotelogger(this.baseUrlRem1 + 'addProduct.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	addDepense(samacaabiyoonwii, description, pointConcerne, categConcernee,
		montant, debPeriode, finPeriode): Promise<any> {


		let postData = {
			samacaabiyoonwii: samacaabiyoonwii, description: description, point: pointConcerne, categorie: categConcernee,
			montant: montant, debPeriode: debPeriode, finPeriode: finPeriode
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'addDepense.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getReportingClientBi(samacaabiyoonwii, idclient): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			idclient: idclient
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'getReportingClientBi.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	ajouterDepot(samacaabiyoonwii, idstock, newDepot, entryPrice, product): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			idstock: idstock, newDepot: newDepot,
			entryPrice: entryPrice, product: product
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'ajouterDepotStock.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	adjustInventaire(samacaabiyoonwii, listArticleInventaire,
		nomDepot, nomCateg, nbreprdcAjustes, totalEcart, valtotalEcart): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			listArticleInventaire: listArticleInventaire, nomDepot: nomDepot,
			nomCateg: nomCateg, nbreprdcAjustes: nbreprdcAjustes,
			totalEcart: totalEcart, valtotalEcart: valtotalEcart
		};

		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'adjustInventairecmup.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
					resolve(backData);
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	addProductMasse(samacaabiyoonwii, listNouveauProduits, nomDepot, refOperationEntree, typeoperation): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			listNouveauProduits: listNouveauProduits,
			nomDepot: nomDepot, refOperationEntree: refOperationEntree, typeoperation: typeoperation
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'addProductMasse.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
					resolve(backData);
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	transfertStock(samacaabiyoonwii, sourceDepot, destinationDepot, listArticles): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			sourceDepot: sourceDepot,
			destinationDepot: destinationDepot,
			listArticles: listArticles
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'transfertStock.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	mettreAjourStockDepot(samacaabiyoonwii, idstock, qteEnStock, entryPrice, product): Promise<any> {

		let postData = {
			samacaabiyoonwii: samacaabiyoonwii, idstock: idstock,
			qteEnStock: qteEnStock, entryPrice: entryPrice, product: product
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'mettreAjourStockDepot.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	mettreAjourCategArtMasse(samacaabiyoonwii, listproduits, nouvelleCateg): Promise<any> {

		let postData = {
			samacaabiyoonwii: samacaabiyoonwii, listproduits: listproduits,
			nouvelleCateg: nouvelleCateg
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'mettreAjourCategArtMasse.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	commanderPanierOLD(codeVendeur: string, panierCommande: any, quantities: any, paymean: string): Promise<ReponseWebService> {
		return new Promise((resolve, reject) => {

			let postData = { code: codeVendeur, panier: panierCommande, quantities: quantities, paymean: paymean };
			let backData: ReponseWebService;

			console.log(postData);
			//this.baseUrlRem1+
			this.remotelogger('http://eaukayar.hybraine.net/bcknd/scommerce/commanderPanier.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {

					resolve(backData);
				}
			);
		});
	}



	sendImageBiCiKaw(datauri: any): Promise<ReponseWebService> {
		return new Promise((resolve, reject) => {

			let postData = { datauri: datauri };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'fileuploader.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {

					resolve(backData);
				}
			);
		});
	}

	//sonsyi
	sendWakhJiCiKaw(datauri: any): Promise<ReponseWebService> {
		return new Promise((resolve, reject) => {

			let postData = { datauri: datauri };
			let backData: ReponseWebService;
			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'audioFileuploader.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {

					resolve(backData);
				}
			);
		});
	}



	mettreAjourDetailsArticleBi(samacaabiyoonwii, idarticle, infoToUpdt, newValue, detailsarticle): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii, id: idarticle,
			infoToUpdt: infoToUpdt, newValue: newValue, detailsarticle: detailsarticle
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'mettreAjourDetailsArticle.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	mettreAjourPrixArticleBi(samacaabiyoonwii, prixDeVente, product): Promise<any> {

		let postData = {
			samacaabiyoonwii: samacaabiyoonwii, prixDeVente: prixDeVente,
			product: product
		};
		let backData: ReponseWebService;
		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'mettreAjourPrixArticleBi.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllPoints(samacaabiyoonwii: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getallpoints.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getAllPointsEtDepots(samacaabiyoonwii: string, idboutique): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAllPointsEtDepots.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllInventaires(samacaabiyoonwii: string, idboutique, deb, fin): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, dateBiniouTambalei: deb, dateBiniouDieekhal: fin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAllInventaires.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllRapportsStock(samacaabiyoonwii: string, idboutique, deb, fin): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, dateBiniouTambalei: deb, dateBiniouDieekhal: fin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAllRapportsStock.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	deleteStockEntry(samacaabiyoonwii: string, idMouvement: number): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, idMouvement: idMouvement };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'deleteStockEntry.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("Delete stock entry completed");
					resolve(backData);
				}
			);
		});
	}

	getDetailInventaire(samacaabiyoonwii: string, idInventaire): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, idInventaire: idInventaire };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getDetailInventaire.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllDepenses(samacaabiyoonwii: string, idboutique, deb, fin): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique, dateBiniouTambalei: deb, dateBiniouDieekhal: fin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAllDepenses.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}

	getsamastock(samacaabiyoonwii: string, idboutique): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, boutique: idboutique };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getsamastock.php', postData).subscribe(
				retourPost => {
					console.log(retourPost);
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllDepots(samacaabiyoonwii: string): Promise<any> {

		let postData = { samacaabiyoonwii: samacaabiyoonwii };
		let backData: ReponseWebService;

		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'getAlldepots.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllKindOfExpenses(samacaabiyoonwii: string): Promise<any> {

		let postData = { samacaabiyoonwii: samacaabiyoonwii };
		let backData: ReponseWebService;

		console.log(postData);

		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'getAllDepenseCategs.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	getAllHabilitations(samacaabiyoonwii: string): Promise<any> {

		let postData = { samacaabiyoonwii: samacaabiyoonwii };
		let backData: ReponseWebService;
		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'getallhabilitations.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
					console.log(backData);
				},
				response => {
					console.log(backData);
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}



	getAllPartners(samacaabiyoonwii): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			let backData: any;

			this.remotelogger(this.baseUrlRem1 + 'getallusers.php', postData).subscribe(
				retourPost => {
					console.log("THere we are 62");
					backData = retourPost;
					console.log("*****");
					console.log(backData);
				},
				response => {
					console.log("THere we are 67");
					console.log(response);

					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '', status: true, chauffeurs: [] };
				},
				() => {
					console.log("THere we are 73");
					resolve(backData);
				}
			);
		});
	}


	yeessalaatCaabiWaadji(samacaabiyoonwii, iduser): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, iduser: iduser };
			let backData: ReponseWebService;

			console.log("yeessal:", postData);

			this.remotelogger(this.baseUrlRem1 + 'reinitializePassword.php', postData).subscribe(
				retourPost => {
					console.log(backData);
					backData = retourPost;
				},
				response => {
					console.log(backData);
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}



	soppandietatwoucomptebi(samacaabiyoonwii, iduser, state): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, iduser: iduser, state: state };
			let backData: ReponseWebService;

			console.log("yeessal:", postData);

			this.remotelogger(this.baseUrlRem1 + 'soppandietatwoucomptebi.php', postData).subscribe(
				retourPost => {
					console.log(backData);
					backData = retourPost;
				},
				response => {
					console.log(backData);
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}



	getAllProfils(samacaabiyoonwii): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getallprofils.php', postData).subscribe(
				retourPost => {
					console.log(backData);
					backData = retourPost;
				},
				response => {
					console.log(backData);
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	creerDepotForBoutique(samacaabiyoonwii, companyName, boutique, adressepoint): Promise<ReponseWebService> {

		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			companyName: companyName,
			boutique: boutique,
			adressepoint: adressepoint
		};
		let backData: ReponseWebService;

		console.log(postData);

		return new Promise((resolve, reject) => {

			this.remotelogger(this.baseUrlRem1 + 'addDepot.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}



	createPointAgency(samacaabiyoonwii, companyName, regionPoint, adressepoint): Promise<ReponseWebService> {

		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			companyName: companyName,
			regionPoint: regionPoint,
			adressepoint: adressepoint
		};
		let backData: ReponseWebService;

		console.log(postData);

		return new Promise((resolve, reject) => {

			this.remotelogger(this.baseUrlRem1 + 'addPoint.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	creerProfil(samacaabiyoonwii, nomprofil, otherInfos): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, nomprofil: nomprofil, otherInfos: otherInfos };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'creerprofil.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	updateProfil(samacaabiyoonwii, nomprofil, otherInfos, idprofil): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, nomprofil: nomprofil, otherInfos: otherInfos, idprofil: idprofil };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'updateprofil.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	updateUserdetails(samacaabiyoonwii, canal, compliances, iduser): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii, canal: canal, compliances: compliances, iduser: iduser };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'updateUserdetails.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	getSituationsEver(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getSituationAllTimeForMe.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}

	getSituationPeriodeDashbord(samacaabiyoonwii, datedeb, datefin): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { token: samacaabiyoonwii, samacaabiyoonwii: samacaabiyoonwii, dateDebut: datedeb, dateFin: datefin };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getSituationPeriode.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	getBigChiffres(samacaabiyoonwii): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'getAggrega.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}



	createUserComparateur(body): Promise<ReponseWebService> {

		return new Promise((resolve, reject) => {
			let postData = body;
			let backData: ReponseWebService;

			console.log(postData);

			this.remotelogger(this.baseUrlRem1 + 'addUser.php', postData).subscribe(
				retourPost => {
					backData = retourPost;
				},
				response => {
					backData = { statutreq: 0, message: "Erreur! Vérifiez votre connexion Internet", data: '' };
				},
				() => {
					resolve(backData);
				}
			);
		});
	}


	getAllShops(samacaabiyoonwii: string): Promise<any> {
		return new Promise((resolve, reject) => {
			let postData = { samacaabiyoonwii: samacaabiyoonwii };
			this.remotelogger(this.baseUrlRem1 + 'getAllShops.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	transfertStockInter(samacaabiyoonwii, sourceDepot, destinationShopId, listArticles): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			sourceDepot: sourceDepot,
			destinationShopId: destinationShopId,
			listArticles: listArticles
		};
		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'transfertStockInter.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	getPendingTransfers(samacaabiyoonwii): Promise<any> {
		let postData = { samacaabiyoonwii: samacaabiyoonwii };
		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'getPendingTransfers.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	validateReception(samacaabiyoonwii, transferId, destinationDepot, receivedItems): Promise<any> {
		let postData = {
			samacaabiyoonwii: samacaabiyoonwii,
			transferId: transferId,
			destinationDepot: destinationDepot,
			receivedItems: receivedItems
		};
		return new Promise((resolve, reject) => {
			this.remotelogger(this.baseUrlRem1 + 'validateReception.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}


	// --- Nouveaux endpoints pour Caisse, Banque et Fournisseur ---

	// Caisse
	caisseApi(samacaabiyoonwii: string, action: string, data: any = {}): Promise<any> {
		let postData = { samacaabiyoonwii, action, ...data };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'api_caisse.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	// Banque
	banqueApi(samacaabiyoonwii: string, action: string, data: any = {}): Promise<any> {
		let postData = { samacaabiyoonwii, action, ...data };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'api_banque.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	updateCompteBancaire(samacaabiyoonwii: string, compte: any): Promise<any> {
		return this.banqueApi(samacaabiyoonwii, 'update_compte', {
			id: compte.id,
			nom_banque: compte.nom_banque,
			numero_compte: compte.numero_compte
		});
	}

	// Fournisseur
	fournisseurApi(samacaabiyoonwii: string, action: string, data: any = {}): Promise<any> {
		let postData = { samacaabiyoonwii, action, ...data };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'api_fournisseur.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	updateFournisseur(samacaabiyoonwii: string, fournisseur: any): Promise<any> {
		return this.fournisseurApi(samacaabiyoonwii, 'update_fournisseur', {
			id: fournisseur.id,
			nom: fournisseur.nom,
			telephone: fournisseur.telephone,
			adresse: fournisseur.adresse
		});
	}

	// User points association
	userPointsApi(samacaabiyoonwii: string, action: string, target_user: number, points?: number[]): Promise<any> {
		let postData = { samacaabiyoonwii, action, target_user, ...(points ? { points } : {}) };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'api_user_points.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	updateBoutiqueName(samacaabiyoonwii: string, idPoint: any, nouveauNom: string, caisseType: string = 'Automatique'): Promise<any> {
		let postData = { samacaabiyoonwii, idPoint, nouveauNom, caisse_type: caisseType, caisseType: caisseType };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'updateBoutiqueName.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	updateDepotName(samacaabiyoonwii: string, idDepot: any, nouveauNom: string): Promise<any> {
		let postData = { samacaabiyoonwii, idDepot, nouveauNom };
		return new Promise((resolve) => {
			this.remotelogger(this.baseUrlRem1 + 'updateDepotName.php', postData).subscribe(
				retourPost => { resolve(retourPost); },
				response => { resolve({ statutreq: 0, message: "Erreur connexion", data: '' }); }
			);
		});
	}

	remotelogger(url: string, sentData: any) {
		return this.http.post<ReponseWebService>(url, sentData, httpOptions);
	}


}
